module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl3-100.22505380.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl3-100.png
// module id = 3502
// module chunks = 11